module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Manage blog posts","addNewPost":"Add new post","noSavedPost":"No post saved for the moment."},"fr":{"title":"Gérer les posts","addNewPost":"Ajouter nouveau post","noSavedPost":"Pas de postes pour le moment."}}')
  delete Component.options._Ctor
}
